import { Component } from '@angular/core';
import { Extrainfo, Volume } from 'src/app/models/form/book-data';
import { FormDataService } from 'src/app/services/form-data.service';

@Component({
  selector: 'app-scania-other-details',
  templateUrl: './scania-other-details.component.html',
  styleUrls: ['./scania-other-details.component.scss']
})
export class ScaniaOtherDetailsComponent {
  
  extrainfo:Extrainfo;
  volume:Volume;

constructor (
  private formDataService : FormDataService ,  
  public formData : FormDataService
  ) 
  {

  this.extrainfo = formDataService.extrainfo;
  this.volume = formDataService.volume;

}

}
